import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UnifyNotification } from "../interfaces/unify_notification.interface";

@Injectable({
  providedIn: "root",
})
export class UnifyNotificationService {
  constructor(private http: HttpClient) {}

  getNotifications(userId: string): Observable<UnifyNotification[]> {
    return this.http.get<UnifyNotification[]>(
      `${environment.apiBase}/get_notifications/${userId}/`
    );
  }

  openNotification(NotificationId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiBase}/open_notification/${NotificationId}/`,
      {}
    );
  }
}
